/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/10/8 17:44
 * @FileName: openAnAccountOnline.js
 * @LastEditor: 2022/10/8 17:44
 * @Name: openAnAccountOnline
 */

const openAnAccountOnline = {
  routes: [
    {
      path: '/openAnAccountOnline',
      name: 'openAnAccountOnline',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/open-an-account-online/open-an-account-online.vue')
    }
  ]
};
export default openAnAccountOnline;



// WEBPACK FOOTER //
// ./src/project/router/openAnAccountOnline.js